import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateColumns
 */

type Props = {
  onActionEdit: (idFuncionarioAssinatura: number | null, openState: boolean) => void,
  onActionDelete: (idFuncionarioAssinatura: number | null, openState: boolean) => void,
  onActionDownload: (idFuncionarioAssinatura: number, arquivoNome: string) => void,
};

export const GenerateFuncionarioAssinaturaColumns = ({
  onActionEdit,
  onActionDelete,
  onActionDownload,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "A";
      case 0:
        return "I";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 75,
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value ? 1 : 0)}
            color={computeItemStatusColor(params.value ? 1 : 0)}
            description={computeItemStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "funcionario",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "cargo",
      filterable: false,
      headerName: "Cargo",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "nroRegistro",
      filterable: false,
      headerName: "Nº Registro",
      minWidth: 100,
      width: 100,
      sortable: false,
      align: "center",
    },
    {
      field: "arquivo",
      filterable: false,
      headerName: "Arquivo",
      width: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        idFuncionarioAssinatura: rows['idFuncionarioAssinatura'],
        nomeArquivo: rows['nomeArquivo'],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const idFuncionarioAssinatura = params.value['idFuncionarioAssinatura'] as number;
        const nomeArquivo = params.value['nomeArquivo'] as string;

        return (
          <Button
            onMouseDown={() => onActionDownload(idFuncionarioAssinatura, nomeArquivo)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: '9.5rem',
            }}>
            {nomeArquivo && nomeArquivo.length > maxSize ? `${nomeArquivo.substring(0, maxSize)}...` : nomeArquivo}
          </Button>
        );
      },
    },
    {
      field: 'idFuncionarioAssinatura',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}